interface Props {
  eyebrow?: string
  title: string
  description?: string
  centered?: boolean
  light?: boolean
}

function SectionHeading({ eyebrow, title, description, centered, light }: Props) {
  return (
    <div className={`${centered ? 'text-center mx-auto' : ''} max-w-3xl ${centered ? '' : ''}`}>
      {eyebrow ? (
        <div className={`flex items-center gap-3 mb-5 ${centered ? 'justify-center' : ''}`}>
          <span className="w-8 h-px bg-orange-accent" />
          <span className={`text-xs uppercase tracking-[0.25em] font-semibold ${light ? 'text-orange-accent' : 'text-orange-accent'}`}>
            {eyebrow}
          </span>
        </div>
      ) : null}
      <h2 className={`font-display text-4xl md:text-5xl lg:text-[3.25rem] font-bold leading-[1.1] ${light ? 'text-white' : 'text-navy'}`}>
        {title}
      </h2>
      {description ? (
        <p className={`mt-6 text-lg leading-relaxed ${light ? 'text-white/75' : 'text-muted'}`}>
          {description}
        </p>
      ) : null}
    </div>
  )
}

export default SectionHeading
